<template>
    <div v-show="this.isFinalVisible && isScrolledToTop">
        <slot :hide="hide" :params="params" :set-param="setParam"></slot>
    </div>
</template>

<script>
import smartToggle from "../../mixins/smartToggle";

export default {
    name: 'Ticker',

    mixins: [smartToggle],

    props: {
        cookie: {type: String, required: false},
        cookieDuration: {type: Number, default: 0},
    },

    data() {
        return {
            params: {},
            isScrolledToTop: true
        };
    },

    watch: {
        isVisible(newValue) {
            if (this.cookie) {
                if (newValue) {
                    $cookies.remove(this.cookie);
                } else {
                    $cookies.set(this.cookie, 1, this.cookieDuration);
                }
            }
        },
    },

    methods: {
        setParam(path, value) {
            this.$set(this.params, path, value);
        },

        setParams(params) {
            this.params = params;
        },
        handleScroll() { // hide ticker if the page is not scrolled to top on mobile
            if (window.innerWidth <= 767) {
                this.isScrolledToTop = window.scrollY === 0;
            }
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
}
</script>
